import { useApiBase } from './useApiBase'

export interface Product {
  // Basic information
  productId: string
  title: string
  description: string
  category: string
  sortOrder: number
  // Active price
  priceId: string
  saleTitle?: string
  amount: number
  billingCycle: string
  // Status flags
  isUnlocked: boolean
  isProcessing: boolean
  isPurchased: boolean
  // 繰り返し購入できる消耗品（切手など）。エリア解放など一回きりの商品は false。
  isRepeatable: boolean
  isNew: boolean
  // UI resources
  thumbnailUrl?: string
}

export interface ListProductsResponse {
  products: Product[]
  total: number
  page: number
  perPage: number
}

export interface FetchClientSecretRequest {
  priceId: string
  mode?: string
  returnUrl?: string
}

export interface CreatePurchaseResponse {
  clientSecret: string
}

export function useCommerceApi() {
  const { apiBase, authenticatedFetch } = useApiBase()
  const config = useRuntimeConfig()

  const listProducts = async (page?: number, perPage?: number) => {
    return authenticatedFetch<ListProductsResponse>(
      `${apiBase}/api/v1/products`,
      {
        method: 'GET',
        query: { page, perPage },
      },
    )
  }

  const createCheckoutSession = async ({ priceId, mode, returnUrl }: FetchClientSecretRequest) => {
    const response = await authenticatedFetch<CreatePurchaseResponse>(
      `${apiBase}/api/v1/purchases`,
      {
        method: 'POST',
        body: {
          priceId,
          quantity: 1,
          mode,
          returnUrl: (
            returnUrl
              ? (returnUrl.startsWith('http') ? returnUrl : `${config.public.serviceDomain}${returnUrl}`)
              : window.location.href
          ),
        },
      },
    )
    return response.clientSecret!
  }

  const cancelCheckoutSession = async (priceId: string) => {
    await authenticatedFetch(
      `${apiBase}/api/v1/purchases/${priceId}`,
      { method: 'DELETE' },
    )
  }

  return { listProducts, createCheckoutSession, cancelCheckoutSession }
}
